<template>
	<div>
		<div class="conLg hidden-xs-only">
			<a class="logoImg" href="http://www.ssjt.cn/"><el-image :src="logoUrl" fit="fill"></el-image></a>
			<a class="menu" :class="isIndexActive" href="index.html">
				<div class="zh">网站首页</div>
				<div class="en">Home</div>
			</a>
			<a class="menu" :class="isAboutActive" href="about.html">
				<div class="zh">公司简介</div>
				<div class="en">About</div>
			</a>
			<a class="menu" :class="isProductActive" href="product.html">
				<div class="zh">产品中心</div>
				<div class="en">Product</div>
			</a>
			<a class="menu" :class="isCaseActive" href="case.html">
				<div class="zh">工程案例</div>
				<div class="en">Case</div>
			</a>
		</div>
		<div class="conMin hidden-sm-and-up">
			<a class="logoImg" href="http://www.ssjt.cn/"><el-image :src="logoUrl" fit="fill"></el-image></a>
			<el-dropdown trigger="click" class="dropdownMenu">
				<span class="el-dropdown-link" style="cursor: pointer;">
					导航菜单<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
					<el-dropdown-menu slot="dropdown">
					<el-dropdown-item>
						<a class="menu" :class="isIndexActive" href="index.html" style=" color: #425066; text-decoration: none !important; ">
							网站首页 Home
						</a>
					</el-dropdown-item>
					<el-dropdown-item>
						<a class="menu" :class="isAboutActive" href="about.html" style=" color: #425066; text-decoration: none !important; ">
							公司简介 About
						</a>
					</el-dropdown-item>
					<el-dropdown-item>
						<a class="menu" :class="isProductActive" href="product.html" style=" color: #425066; text-decoration: none !important; ">
							产品中心 Product
						</a>
					</el-dropdown-item>
					<el-dropdown-item>
						<a class="menu" :class="isCaseActive" href="case.html" style=" color: #425066; text-decoration: none !important; ">
							工程案例 Case
						</a>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
export default {
	name: "Navigate",
	data(){
		return{
			logoUrl: require('../../assets/gczb/img/logo.png')
		}
	},
	props: {
		isIndexActive: String,
		isAboutActive: String,
		isProductActive: String,
		isCaseActive: String
	}
}
</script>

<style scoped>
	.menuActive{ color: #d59216 !important; }

	.conLg{ display: flex; height: 100px; width: 100%; background: #ffffff; position: fixed; z-index: 999; border-bottom: 5px solid #cfd6e0; }
	.conLg .logoImg{ padding: 15px 20px 15px 45px; }
	.conLg .logoImg:hover{ background: none; }
	.conLg .zh{ font-size: 15px; }
	.conLg .en{ font-size: 12px; }
	.conLg .menu{ margin-left: 30px; width: 120px; }
	.conLg a{ text-align: center; padding-top: 34px; color: #425066; text-decoration: none; transition: all 0.15s linear; }
	.conLg a:hover{ color: #ffffff; background: rgba(66, 80, 102, 0.8); }

	.conMin{ display: flex; justify-content: space-between; height: 100px; width: 100%; background: #ffffff; position: fixed; z-index: 999; border-bottom: 5px solid #cfd6e0; }
	.conMin .logoImg{ padding: 15px 10px 15px 28px; }
	.conMin .logoImg:hover{ background: none; }
	.conMin .dropdownMenu{ margin: 37px 20px; }
</style>